import { render } from "./composition.vue?vue&type=template&id=20222b91&scoped=true"
import script from "./composition.vue?vue&type=script&lang=js"
export * from "./composition.vue?vue&type=script&lang=js"

import "./composition.vue?vue&type=style&index=0&id=20222b91&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20222b91"]])

export default __exports__